import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import CalciteScrollableTooltip from "../../shared/CalciteScrollableTooltip";
import CalciteModal from "../../shared/CalciteModal";
import CalciteSelect from "../../shared/CalciteSelect";

const HostingRegionPicker = (props) => {
  const [isHostingRegionOpen, setIsHostingRegionOpen] = useState(false);
  const [activeHostingRegionName, setActiveHostingRegionName] = useState(null);
  const [workingValue, setWorkingValue] = useState(null);

  useEffect(() => {
    if (props.activeHostingRegion) {
      setWorkingValue(props.activeHostingRegion);
    }
  }, []);

  useEffect(() => {
    if (props.activeHostingRegion) {
      setActiveHostingRegionName(
        props.hostingRegions.find((region) => region.value === props.activeHostingRegion)?.name
      );
    }
  }, [props.activeHostingRegion, props.hostingRegions]);

  const handleHostingRegionChange = (event) => {
    const selectedHostingRegion = event.target.selectedOption;
    setWorkingValue(selectedHostingRegion.value);
  };

  const handleHostingRegionClose = (e) => {
    setIsHostingRegionOpen(false);
  };

  const handleHostingRegionClick = () => {
    setIsHostingRegionOpen(true);
    setWorkingValue(props.activeHostingRegion);
  };

  const handleHostingRegionSave = () => {
    setIsHostingRegionOpen(false);
    props.onHostingRegionChange(workingValue);
  };

  return (
    <div className="hosting-region-picker">
      <span className="esri-font-medium ui-text-2">{props.hostingRegionLabel}</span>
      <calcite-button
        round=""
        id="hosting-region-info"
        kind="neutral"
        icon-end="information"
        scale="s"
        appearance="transparent"
      ></calcite-button>
      <span className="hosting-region-picker__separator">:</span>
      <CalciteScrollableTooltip label="Hosting region info" reference-element="hosting-region-info">
        <div className="richtext-container">
          {props.hostingRegionInfoContent && parse(props.hostingRegionInfoContent)}
        </div>
      </CalciteScrollableTooltip>
      {props.disabled ? (
        <span>{activeHostingRegionName}</span>
      ) : (
        <calcite-link icon-end="edit-attributes" onClick={handleHostingRegionClick}>
          {activeHostingRegionName}
        </calcite-link>
      )}
      <CalciteModal
        open={isHostingRegionOpen}
        onClose={handleHostingRegionClose}
        scale="s"
        width="s"
        aria-labelledby="hosting-region-modal-title"
      >
        <div slot="header" id="hosting-region-modal-title">
          {props.hostingRegionSelectHeading}
          <sup className="hosting-region-selection-required">*</sup>
        </div>
        <div slot="content">
          <CalciteSelect onSelectChange={handleHostingRegionChange}>
            {props.hostingRegions.map((region) => (
              <calcite-option
                value={region.value}
                key={region.value}
                selected={region.value === workingValue || undefined}
              >
                {region.name}
              </calcite-option>
            ))}
          </CalciteSelect>
          <calcite-input-message status="warning" icon="exclamation-mark-triangle-f">
            <div className="richtext-container hosting-region-input-message">
              {props.hostingRegionSelectWarningMessage && parse(props.hostingRegionSelectWarningMessage)}
            </div>
          </calcite-input-message>
        </div>
        <calcite-button slot="primary" width="full" onClick={handleHostingRegionSave}>
          {props.continueLabel}
        </calcite-button>
      </CalciteModal>
    </div>
  );
};

export default HostingRegionPicker;
